import React, { useRef } from 'react';
import { TwitterShareButton, EmailShareButton } from 'react-share';
import { XIcon, EmailIcon } from 'react-share';
import './SharingComponent.css';

const SharingComponent = ({ postUrl, postTitle, onClose }) => {
  const hiddenInputRef = useRef(null);

  const handleCopyLink = () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      // Modern clipboard API
      navigator.clipboard.writeText(postUrl).then(
        () => {
          alert('Link copied to clipboard!');
        },
        (err) => {
          console.error('Failed to copy link: ', err);
        }
      );
    } else {
      // Fallback for unsupported environments
      if (hiddenInputRef.current) {
        hiddenInputRef.current.value = postUrl;
        hiddenInputRef.current.select();
        try {
          document.execCommand('copy');
          alert('Link copied to clipboard!');
        } catch (err) {
          console.error('Fallback copy failed: ', err);
        }
      }
    }
  };

  return (
    <div className="share-modal">
      <h3>Share Post</h3>
      <div className="share-options">
        {/* Twitter */}
        <TwitterShareButton url={postUrl} title={postTitle}>
          <XIcon size={32} round={true} />
        </TwitterShareButton>

        {/* Email */}
        <EmailShareButton url={postUrl} subject={postTitle} body="Check this out!">
          <EmailIcon size={32} round={true} />
        </EmailShareButton>

        {/* Copy Link */}
        <button className="copy-link-button2" onClick={handleCopyLink}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="copy-icon"
            style={{ width: '32px', height: '32px', cursor: 'pointer' }}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5A3.375 3.375 0 0 0 6.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0 0 15 2.25h-1.5a2.251 2.251 0 0 0-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 0 0-9-9Z"
            />
          </svg>
        </button>

        {/* Hidden Input for Fallback */}
        <input
          type="text"
          ref={hiddenInputRef}
          style={{ position: 'absolute', left: '-9999px', opacity: 0 }}
          readOnly
        />
      </div>
      <button onClick={onClose} className="close-modal-button2">
        Close
      </button>
    </div>
  );
};

export default SharingComponent;
